/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2021-01-21 10:59:36
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-08-23 15:47:25
 */
import React from 'react'
import {Avatar, Dropdown, Input, message} from 'antd'
import axios from 'axios'
import {ChangeRoom, DeleteTalkList} from '../../../../store/actionCreators'
import {connect} from 'react-redux'
// import { gettalkListonline, getuserinfo } from '../../../service/login'
import {transformtime} from '../../../../utils/tools'
import $ from 'jquery'
import Search from 'antd/lib/input/Search'
// import { getDownloadPathLocal } from '../../../service/localstore'
import {checkfileexist} from '../service/filectrl'
import {MessageEntityFile, MessageEntityImg} from './MessageEntity'
// *******   *********   ***************   **   ***********   ********
// ********  **********            ****   ***   **********   *********
// ***            ******  *******  ****              **            ***
// ***  ********  ***   *********  ****   *************   ******   ***
// ***  ********  ***           *  ***              ***            ***
// ***            ***      **   *  **     ********  ***   ******   ***
// ***  ***   *******      **   *  **     *************            ***
// ***             **           *  **               ***   ******   ***
// **   **  *********      **   *  ****   *************            ***
// **   **  *********      **   *  ****             ********  ***  ***
// **   *         ***           *  ****      ****  ***         **   **
// **   *   ***   ***   *********  ****      ****  ***      *  ***   *
// *   *   ****   ***   *********  ****            ***  *   ***      *
// *      ***     ***   *******    ****      ****   *   *         ****
// ***   **********************  ******   ****************************
class HistoryWindow extends React.PureComponent {
    state = {
        searchtext: '', selectedValue: 'all',//搜索界面中，选中的类型(all,img,file)
    }

    componentDidMount() {
        //解决redux组件ref 不到的问题
        this.props.onRef(this)
        // console.log(this.props.messageList)

    }

    search = ({target: {value}}) => {
        this.setState({searchtext: value})

        // $('*').highlight(value)
        // console.log(this.props.usercacheList)
    }
    setbottom = () => {
        // this.setState({ loading: true })
        setTimeout(() => {
            document.getElementById('msg_end2').scrollIntoView()
            // this.setState({ loading: false })
        }, 10)

    }

    getAllHistory = () => {
        var elementById = document.getElementById("history-of-all")
        var value = elementById.getAttribute("value")
        // console.log(value)
        this.setState({
            selectedValue: value
        })
    }

    getImgHistory = () => {
        var elementById = document.getElementById("history-of-img")
        var value = elementById.getAttribute("value")
        // console.log(value)
        this.setState({
            selectedValue: value
        })
    }

    getFileHistory = () => {
        var elementById = document.getElementById("history-of-file")
        var value = elementById.getAttribute("value")
        // console.log(value)
        this.setState({
            selectedValue: value
        })
    }

    render() {
        const content = (data) => {
            if (data.type === 'text') {

                return data.content.split(this.state.searchtext).map((text, index) => {
                    return (<span key={index}><span
                        style={{background: 'yellow'}}>{index !== 0 && this.state.searchtext}</span><span>{text}</span></span>)
                })

            } else if (data.type === 'message') {
                return <>    {data.content.split(this.state.searchtext).map((text, index) => {
                    return (<span key={index}><span
                        style={{background: 'yellow'}}>{index !== 0 && this.state.searchtext}</span><span>{text}</span></span>)
                })}                    </>

            } else {
                // let filecontent = data.content
                // let strUrl, fileName
                // try {
                //     let filejson = JSON.parse(filecontent)
                //     strUrl = filejson.url
                //     fileName = filejson.fileName
                // } catch (e) {
                //     strUrl = filecontent
                //     fileName = "未知文件"
                // }
                if (data.type === 'img') {
                    return <MessageEntityImg data={data}></MessageEntityImg>
                } else if (data.type === 'file') {
                    return <MessageEntityFile data={data}></MessageEntityFile>
                } else {
                    return null
                }
            }

        }

        // console.log(this.props.messageList[this.props.activeRoom.roomId])
        return (<>
                <div className='history-panel'>
                    <div className='history-search-panel'>
                        {/* <Input className='history-search-panel-searchbox'
                        placeholder={'查找记录'} onChange={this.search.bind(this)}
                        prefix={<img src={require('../../../resources/img/icon-search.png')} />} ></Input> */}
                        <Search className='history-search common-search' value={this.state.searchtext}
                                onChange={this.search} placeholder='搜索'></Search>
                        <div className="history-classify">
                            <div
                                className={this.state.selectedValue === 'all' ? "history-of-all-selected" : "history-of-all"}
                                value="all" id="history-of-all" onClick={() => this.getAllHistory()}>全部
                            </div>
                            <div
                                className={this.state.selectedValue === 'img' ? "history-of-img-selected" : "history-of-img"}
                                value="img" id="history-of-img" onClick={() => this.getImgHistory()}>图片
                            </div>
                            <div
                                className={this.state.selectedValue === 'file' ? "history-of-file-selected" : "history-of-file"}
                                value="file" id="history-of-file" onClick={() => this.getFileHistory()}>文件
                            </div>
                        </div>
                    </div>
                    <div className='history-scroll-panel' id='history-scroll-panel'
                        // style={{ display: this.state.loading ? 'none' : 'block' }}
                         ref={ref => this.scrollpanel = ref}>
                        {this.props.activeRoom && this.props.messageList[this.props.activeRoom.roomId] && this.props.messageList[this.props.activeRoom.roomId].map((message//: ReceiveMesssgeEntity
                            , index) => {
                            return this.state.selectedValue === 'all' ?
                                <div className='history-message-panel' key={index}
                                     style={{
                                         display: message.type === 'text' ? message.content && message.content.indexOf(this.state.searchtext) != -1 ? 'block' : 'none' : message.content.fileName && message.content.fileName.indexOf(this.state.searchtext) != -1 ? 'block' : 'none'
                                     }}
                                >
                                    <Avatar
                                        src={this.props.usercacheList[message.userId] ? this.props.usercacheList[message.userId].avatar : ''}
                                        className={'history-chatavatar'}></Avatar>
                                    <div className='history-text'>
                                        <div className='history-text-up'>
                                            <div className='history-chatname'>
                                                {this.props.usercacheList[message.userId] ? this.props.usercacheList[message.userId].userName : ''}
                                            </div>
                                            <div className='history-time'>
                                                {transformtime(message.time)}
                                            </div>
                                        </div>
                                        <div className='history-content'>
                                            {content(message)}
                                        </div>
                                    </div>
                                </div> : this.state.selectedValue === 'img' ? <>
                                    {message.type === 'img' ? <div className='history-message-panel' key={index}
                                                                   style={{display: message.content.indexOf(this.state.searchtext) != -1 ? 'block' : 'none'}}
                                    >
                                        <Avatar
                                            src={this.props.usercacheList[message.userId] ? this.props.usercacheList[message.userId].avatar : ''}
                                            className={'history-chatavatar'}></Avatar>
                                        <div className='history-text'>
                                            <div className='history-text-up'>
                                                <div className='history-chatname'>
                                                    {this.props.usercacheList[message.userId] ? this.props.usercacheList[message.userId].userName : ''}
                                                </div>
                                                <div className='history-time'>
                                                    {transformtime(message.time)}
                                                </div>
                                            </div>
                                            <div className='history-content'>
                                                {content(message)}
                                            </div>
                                        </div>
                                    </div> : <></>}
                                </> : <>
                                    {message.type === 'file' ? <div className='history-message-panel' key={index}
                                                                    style={{display: message.content.indexOf(this.state.searchtext) != -1 ? 'block' : 'none'}}
                                    >
                                        <Avatar
                                            src={this.props.usercacheList[message.userId] ? this.props.usercacheList[message.userId].avatar : ''}
                                            className={'history-chatavatar'}></Avatar>
                                        <div className='history-text'>
                                            <div className='history-text-up'>
                                                <div className='history-chatname'>
                                                    {this.props.usercacheList[message.userId] ? this.props.usercacheList[message.userId].userName : ''}
                                                </div>
                                                <div className='history-time'>
                                                    {transformtime(message.time)}
                                                </div>
                                            </div>
                                            <div className='history-content'>
                                                {content(message)}
                                            </div>
                                        </div>
                                    </div> : <></>}
                                </>
                        })

                        }
                        <div id='msg_end2' style={{width: '100%', height: 20, float: 'left'}}></div>

                    </div>
                    <div className='history-bottom-panel'>
                    </div>
                </div>
            </>)
    }
}

const mapState = state => ({
    user: state.userReducer.get('user').toJS(),
    activeRoom: state.userReducer.get('activeRoom'),
    messageList: state.messageReducer.get('messageList').toJS(),
    usercacheList: state.cacheReducer.get('usercacheList').toJS(),
})

const mapDispatch = dispatch => ({
    ChangeRoom(param) {
        dispatch(ChangeRoom(param))
    }, DeleteTalkList(param) {
        dispatch(DeleteTalkList(param))
    }
})

export default connect(mapState, mapDispatch)(HistoryWindow)
